<template>
<!-- FOOTER -->
<footer class="footer" :class="{ open: $store.state.footer.active, close: !$store.state.footer.active}">
  <button class="footer_btn" @click="toggleFooter">© ANTENNISTE - PRTV</button>
  <div class="footer_content">
    <aside class="legals">
      <ul>
        <li><a href="#/mentions-legales">Mentions légales</a></li>
        <li><a href="#/cgu">CGU</a></li>
        <li><a href="#/faq">FAQ</a></li>
        <li><a href="https://www.anfr.fr/" target="_blank">Contact</a></li>
      </ul>
      <p class="versionLabel">Version {{versionNumber}}</p>
    </aside>
    <aside class="socials">
      <p class="title">Suivre l'Agence nationale des fréquences</p>
      <ul>
        <li><a class="link" href="http://www.anfr.fr">www.anfr.fr</a></li>
      </ul>
      <div class="icons">
        <a class="facebook" href="https://www.facebook.com/agencenationaledesfrequences/" title="Facebook" target="_blank"></a>
        <a class="twitter" href="https://twitter.com/recevoirlatnt" title="Twitter" target="_blank"></a>
        <a class="flickr" href="https://www.flickr.com/anfr/" title="Flickr" target="_blank"></a>
        <a class="linkedin" href="https://www.linkedin.com/company/anfr/" title="LinkedIn" target="_blank"></a>
      </div>
    </aside>
    <aside class="logo">
      <p class="title">Un site web de l'ANFR</p>
      <a href="https://www.recevoirlatnt.fr" target="_blank">
        <img src="../../assets/img/logo-anfr.svg" alt="PRTV" class="logo_anfr">
      </a>
    </aside>
  </div>
</footer>
</template>

<script>
import '../../assets/css/footer.css'
export default {
  name: 'CrFooter',
  components: {},
  data() {
    return {
      versionNumber: null
    }
  },
  mounted() {
    this.versionNumber = require('../../../package.json').version;
  },
  methods: {
    toggleFooter: function() {
      this.$store.dispatch('footerToggle')
    }
  }
}
</script>

<style scoped>
.versionLabel {
  color: white;
  margin-top: 20px;
  padding-left: 15px;
}
</style>
